import { DateTime } from 'luxon';

import type { DateRangeId } from '../../../store/slices/asset-listing/DateRangeId';

export enum Transform {
  Add,
  Subtract,
}

export const applyDateRangeTransform: (dt: DateTime, dateRangeId: DateRangeId, transform: Transform) => DateTime = (
  dt,
  dateRangeId,
  transform
) => {
  let amount = 0;
  let unitOfMeasurement: 'days' | 'weeks' | 'months' | 'years' = 'days';

  switch (dateRangeId) {
    case '1-day':
      amount = 1;
      unitOfMeasurement = 'days';
      break;
    case '3-days':
      amount = 3;
      unitOfMeasurement = 'days';
      break;
    case '1-week':
      amount = 1;
      unitOfMeasurement = 'weeks';
      break;
    case '2-weeks':
      amount = 2;
      unitOfMeasurement = 'weeks';
      break;
    case '1-month':
      amount = 1;
      unitOfMeasurement = 'months';
      break;
    case '2-months':
      amount = 2;
      unitOfMeasurement = 'months';
      break;
    case '6-months':
      amount = 6;
      unitOfMeasurement = 'months';
      break;
    case '1-year':
      amount = 1;
      unitOfMeasurement = 'years';
      break;
    default:
      throw `Unexpected dateRangeId: ${dateRangeId}`;
  }

  switch (transform) {
    case Transform.Add:
      return DateTime.fromISO(dt).plus({ [unitOfMeasurement]: amount }); // DateTime.fromJSDate(baseline).plus({[unitOfMeasurement]: amount }})
    case Transform.Subtract:
      return DateTime.fromISO(dt).minus({ [unitOfMeasurement]: amount });
    default:
      throw `Unexpected transform: ${transform}`;
  }
};
